<div class="ms-medium-b">
  <h2 class="nordic-blue-900-text text-icon-primary font-headline-small">{{ content().teaserTitle }}</h2>
  @if (content().externallyDisplayedDate) {
    <fin-date class="block ms-small-y" [date]="content().externallyDisplayedDate" />
  }
  <div [innerHTML]="content().teaserText | finSafe: 'html'"></div>

  @if (content().url) {
    <a
      [finLink]="content().url"
      (click)="emitClick()"
      class="flex flex--middle nordic-blue-900-text text-icon-primary no-underline pr-xxsmall-t underline-hover font-body-medium-bold"
    >
      <span class="title">{{ 'readMore' | finLocalization }}</span>
      <span class="is-vishidden">{{ content().teaserTitle }}</span>
      <span class="cta">
        <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
      </span>
    </a>
  }
</div>
